import {
  REACT_APP_API_BASE_URL,
  REACT_APP_FEATURE_FLAG_QUOTE_BID_SIZE_PAGINATION
} from '../config/settings/environment'
import { factoryService, getJsonRequest, postJsonRequest } from '@chilecompra/react-kit/requests'

/**
 * Gets different status of the quote, buyer option.
 */
export const getQuoteSummary = factoryService(({ quoteId, pageId = 0 }) => {
  return getJsonRequest(
    `${REACT_APP_API_BASE_URL}/v1/compra-agil/solicitud/${quoteId}?size=${REACT_APP_FEATURE_FLAG_QUOTE_BID_SIZE_PAGINATION}&page=${pageId}`
  )
})

/**
 * Get company data.
 */
export const getCompany = factoryService(({ bidId }) => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/solicitud/${bidId}/empresa`)
})

/**
 * Get lists of causes for inadmissibility by quote
 */
export const getCausesInadmissibility = factoryService(() => {
  return getJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/inadmisibilidad/listarCausales`)
})

/**
 * Post: declaration inadmissibility by quote
 */
export const postDeclarationInadmissibility = factoryService(payload => {
  const body = {
    idCotizacion: payload.quoteBidId,
    idSolicitudCotizacion: payload.quoteId,
    justificacion: payload.justification,
    idTipoInadmisibilidad: payload.type
  }

  return postJsonRequest(`${REACT_APP_API_BASE_URL}/v1/compra-agil/inadmisibilidad/guardar`, { body })
})
